import { render, staticRenderFns } from "./RegisterBanner.vue?vue&type=template&id=6d905326&scoped=true&"
import script from "./RegisterBanner.vue?vue&type=script&lang=js&"
export * from "./RegisterBanner.vue?vue&type=script&lang=js&"
import style0 from "./RegisterBanner.vue?vue&type=style&index=0&id=6d905326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d905326",
  null
  
)

export default component.exports